var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrcQty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#03B675"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2352 4.84375H9.76128C9.34947 4.84375 9.01562 5.17759 9.01562 5.58941V7.08072C9.01562 7.49254 9.34947 7.82638 9.76128 7.82638H14.2352C14.647 7.82638 14.9809 7.49254 14.9809 7.08072V5.58941C14.9809 5.17759 14.647 4.84375 14.2352 4.84375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9791 6.33594H16.4705C16.866 6.33594 17.2453 6.49306 17.525 6.77273C17.8047 7.05241 17.9618 7.43173 17.9618 7.82725V17.709C17.9618 18.1046 17.8047 18.4839 17.525 18.7636C17.2453 19.0432 16.866 19.2004 16.4705 19.2004H7.52257C7.12704 19.2004 6.74772 19.0432 6.46805 18.7636C6.18837 18.4839 6.03125 18.1046 6.03125 17.709V7.82725C6.03125 7.43173 6.18837 7.05241 6.46805 6.77273C6.74772 6.49306 7.12704 6.33594 7.52257 6.33594H9.01388",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.162 11.2266L10.2049 15.1837L8.40625 13.385",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.597 12.6719L12.899 15.3699L12.3594 14.8303",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrcQty);
export default __webpack_public_path__ + "static/media/grcQty.0b2d98c1d3888c5e8364699c56b1e81c.svg";
export { ForwardRef as ReactComponent };